<div class="cropper-picture-modal">
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <div class="containers" *ngIf="translation && !loading">
      <div class="saving-overlay" *ngIf="saving"></div>
      <md2-tabs
        *ngIf="pictogram && pictogram.pictureURL"
        [selectedIndex]="selectedIndex"
      >
        <md2-tab
          class="picto-white"
          label="Pictogram"
          [active]="data.optional2 === 'Pictogram'"
          *ngIf="editMode && pictogram.pictureURL"
        >
          <i
            >Click on the picture below or drag and drop to upload your own
            picture</i
          >
          <br />
          <input
            id="file_upload_picto"
            type="file"
            style="visibility: hidden; display: none"
            (change)="fileChange($event)"
          />
          <div (drop)="onDrop($event)" (dragover)="onDragOver($event)">
            <img
              class="pictogram"
              *ngIf="pictogram.pictureURL"
              [src]="pictogram.pictureURL || pictogram.blob"
              (click)="upload()"
            />
          </div>
        </md2-tab>
        <md2-tab
          class="picto-white"
          label="Pictogram"
          [active]="data.optional2 === 'Pictogram'"
          *ngIf="!editMode"
        >
          <img
            class="pictogram"
            *ngIf="pictogram.pictureURL"
            [src]="pictogram.pictureURL || pictogram.blob"
          />
        </md2-tab>
      </md2-tabs>
    </div>
    <input
      *ngIf="pictogram && !pictogram.pictureURL"
      id="file_upload_picto"
      type="file"
      style="visibility: hidden; display: none"
      (change)="fileChange($event)"
    />
  </md-dialog-content>
  <md-dialog-actions *ngIf="editMode">
    <div class="error">{{ errorMessage }}</div>
    <app-spinner *ngIf="saving"></app-spinner>
    <div class="buttons">
      <button md-raised-button md-dialog-close [disabled]="saving">
        <md-icon>cancel</md-icon>
        Cancel
      </button>
      <div>
        <button
          md-raised-button
          color="warn"
          (click)="deletePictogram()"
          [disabled]="saving"
          *ngIf="data.type === 'translate' && pictogram && pictogram.pictureURL"
        >
          <md-icon>delete</md-icon>
          <span *ngIf="data.type === 'translate'">Delete</span>
        </button>
        <button
          md-raised-button
          color="primary"
          (click)="resetToPlaceholder()"
          [disabled]="saving"
          *ngIf="
            data.type === 'translate' &&
            isPlaceholder !== true &&
            pictogram &&
            pictogram.pictureURL
          "
        >
          <md-icon>refresh</md-icon>
          <span *ngIf="data.type === 'translate'">Reset to Placeholder</span>
        </button>
        <button
          md-raised-button
          color="primary"
          (click)="upload()"
          [disabled]="saving"
          *ngIf="
            data.type === 'translate' && pictogram && !pictogram.pictureURL
          "
        >
          <md-icon>upload</md-icon>
          <span *ngIf="data.type === 'translate'">Upload</span>
        </button>
        <button
          md-raised-button
          color="accent"
          (click)="uploadPicture()"
          [disabled]="saving"
        >
          <md-icon *ngIf="data.type === 'translate'">save</md-icon>
          <span *ngIf="data.type === 'translate'">Save</span>
          <md-icon *ngIf="data.type !== 'translate'">check</md-icon>
          <span *ngIf="data.type !== 'translate'">OK</span>
        </button>
      </div>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/pictogram-modal/pictogram-modal.component.html